import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Table from '../../lib/ui/components/table/Table';
const AssessmentList = ({handleNameClick}) => {
  const [jobProfiles, setJobProfiles] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  useEffect(() => {
    const fetchJobProfiles = async () => {
      const endpoint = `/fetch-assessment-profile-list`;
      const url = apiUrl + endpoint;

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
          const files = await response.json();
          console.log('files:', files);
          const profiles = await Promise.all(
            files.map(async (file) => {
              const uid = file.replace('.json', '');
              const fileEndpoint = `/fetch-file/${uid}`;
              const fileUrl = apiUrl + fileEndpoint;
              const res = await fetch(fileUrl, {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                },
              });
              console.log('Fetching job profile from:', fileUrl);
              return res.json();
            })
          );
          setJobProfiles(profiles);
        } else {
          console.error('Error fetching job profile list:', response.statusText);
        }
      } catch (error) {
        console.error('Error fetching job profile list', error);
      }
    };

    fetchJobProfiles();
  }, []);

  const handleFetchFile = async (uid) => {
    const endpoint = `/fetch-result/${uid}`;
    const url = apiUrl + endpoint;
    console.log('Fetching result with UID:', uid);

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Fetched data:', data.analysis);
        navigate("/assessment-results", { state: { analysis: data.analysis } });
      } else {
        console.error('Error fetching file:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching file', error);
    }
  };

  return (
    <div className="overflow-x-auto">
      <h2>Evaluations</h2>
      <Table>
        <Table.Head>
          <Table.HeadCell>Role</Table.HeadCell>
          <Table.HeadCell>Name</Table.HeadCell>
          <Table.HeadCell>Completion Date</Table.HeadCell>
          <Table.HeadCell>
            <span className="sr-only">Details</span>
          </Table.HeadCell>
        </Table.Head>
        <Table.Body className="divide-y">
          {jobProfiles.map((profile) => (
            <Table.Row key={profile.uid} className="bg-white dark:border-gray-700 dark:bg-gray-800">
              <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
              
                  {profile.job_role}

              </Table.Cell>
              <Table.Cell>
              <a onClick={() => handleNameClick(profile.analysis, profile.username, profile.time)} className="font-medium text-cyan-600 hover:underline cursor-pointer">
                {profile.username}
                </a>
                </Table.Cell>
              
              <Table.Cell>
                {profile.time && !isNaN(new Date(profile.time)) && new Date(profile.time).getFullYear() > 1970
                  ? new Date(profile.time).toLocaleDateString("en-US")
                  : profile.time || 'N/A'}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </div>
  );
};

export default AssessmentList;